import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IMajorTech } from "../../models/MajorTech";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";

import { JVCheckbox } from "../../shared/JVCheckbox";
import { ITeamsDropdown } from "../../models/IDropdown";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IPipelineStatus } from "./IPipelineStatus";
import { EmptyPipelineStatus } from "./EmptyPipelineStatus";

const schema = yup.object({
    status_Name: yup.string().required(" Status Name is required*"),
    // minimum_Rate:yup.number().typeError("should be a number").required("minimum rate is required").nullable(),
    req_CategoryStatus: yup.boolean().nullable(),
});

interface Iprops {
    singleData: IPipelineStatus,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

interface IRecruiterListDropdown {
    login_ID: number,
    user_Name: string,
    is_Allocated: number,
}


export const Form = (props: Iprops) => {
    const [teams, setTeams] = useState<Array<ITeamsDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IRecruiterListDropdown>>();
    const [selectedRecruiters, setSelectedRecruiters] = useState<Array<IRecruiterListDropdown>>();
    const [selectedTeams, setSelectedTeams] = useState<Array<ITeamsDropdown>>();
    const [isTeam, setIsTeam] = useState(false);
    const [isRecruiterAllocation, setIsRecruiterAllocation] = useState(false);
    const [loading, setLoading] = useState(false);
    const [subCategory, setSubCategory] = useState(false);
    const [isAllocation, setIsAllocation] = useState(false);


    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IPipelineStatus>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });


    const saveToDB = async (body: IPipelineStatus) => {
        setLoading(true);
        const method = props.singleData.status_ID ? "PUT" : "POST";
        const message = props.singleData.status_ID ? "Updated Successfully" : "Added Successfully";

     

            const response = await Fetch("Pipeline_Status_Mast", method, body, null, props.toast);
            if (response) {
                props.hideDialog();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                props.setReload(!props.reload);
                reset(EmptyPipelineStatus)
                setLoading(false);
            }
        

        setLoading(false);
    
    }

 
    // useEffect(() => {
    //     loadTeams();
       
    // }, [props.open]);
    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.isSubCategory) {
            setSubCategory(true);
        }
      
    }, [props.singleData]);
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
         
            if (name === "isSubCategory") {
                if (value.isSubCategory === true) setSubCategory(true);
                else setSubCategory(false);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

   
 
    const onHide = () => {
        props.hideDialog();
        // reset(EmptyMajorTech);
       
    }

    function onSubmit(data: IPipelineStatus) {
        console.log(data);
         saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Pipeline Status" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={2} required label="Status Name" control={control} name="status_Name"  error={errors.status_Name?.message} />
                <div style={{ marginTop: '10px', marginBottom: '20px', width: '100%' }}></div>
                <JVCheckbox column={4} control={control} name="isSubCategory" label="Sub Category" />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}
